import dynamic from 'next/dynamic'

import { type IconProps } from './assets/interface'

export { type IconProps }

export const AccountSwitchIllustration = dynamic(() =>
  import('./account-switch.illustration').then(mod => mod.AccountSwitchIllustration)
)
export const AlertPhoneIllustration = dynamic(() =>
  import('./alert-phone.illustration').then(mod => mod.AlertPhoneIllustration)
)
export const AlgarIllustration = dynamic(() => import('./algar.illustration').then(mod => mod.AlgarIllustration))
export const AlgarLandlineIllustration = dynamic(() =>
  import('./algar-landline.illustration').then(mod => mod.AlgarLandlineIllustration)
)
export const AppleStoreIllustration = dynamic(() =>
  import('./apple-store.illustration').then(mod => mod.AppleStoreIllustration)
)
export const AppleStoreBlackIllustration = dynamic(() =>
  import('./apple-store-black.illustration').then(mod => mod.AppleStoreBlackIllustration)
)
export const ArrowNorthWest = dynamic(() => import('./arrow-north-west.illustration').then(mod => mod.ArrowNorthWest))
export const ArrowSouthEast = dynamic(() => import('./arrow-south-east.illustration').then(mod => mod.ArrowSouthEast))
export const AvatarPfIllustration = dynamic(() =>
  import('./avatar-pf.illustration').then(mod => mod.AvatarPfIllustration)
)
export const AvatarPjIllustration = dynamic(() =>
  import('./avatar-pj.illustration').then(mod => mod.AvatarPjIllustration)
)
export const BrowserErrorIllustration = dynamic(() =>
  import('./browser-error.illustration').then(mod => mod.BrowserErrorIllustration)
)
export const CalendarIllustration = dynamic(() =>
  import('./calendar.illustration').then(mod => mod.CalendarIllustration)
)
export const CalendarCheckedIllustration = dynamic(() =>
  import('./calendar-checked.illustration').then(mod => mod.CalendarCheckedIllustration)
)
export const CalendarLoadingIllustration = dynamic(() =>
  import('./calendar-loading.illustration').then(mod => mod.CalendarLoadingIllustration)
)
export const CalendarNegativeIllustration = dynamic(() =>
  import('./calendar-negative.illustration').then(mod => mod.CalendarNegativeIllustration)
)
export const CalendarSuccessIllustration = dynamic(() =>
  import('./calendar-success.illustration').then(mod => mod.CalendarSuccessIllustration)
)
export const CalendarSuccessBalloonIllustration = dynamic(() =>
  import('./calendar-success-balloon.illustration').then(mod => mod.CalendarSuccessBalloonIllustration)
)
export const CannotLoginThinkingDuoIllustration = dynamic(() =>
  import('./cannot-login-thinking-duo.illustration').then(mod => mod.CannotLoginThinkingDuoIllustration)
)
export const CellphoneIllustration = dynamic(() =>
  import('./cellphone.illustration').then(mod => mod.CellphoneIllustration)
)
export const CellphoneApprovedIllustration = dynamic(() =>
  import('./cellphone-approved.illustration').then(mod => mod.CellphoneApprovedIllustration)
)
export const CellphoneRejectedIllustration = dynamic(() =>
  import('./cellphone-rejected.illustration').then(mod => mod.CellphoneRejectedIllustration)
)
export const CellphoneStone = dynamic(() => import('./cellphone-stone.illustration').then(mod => mod.CellphoneStone))
export const CircleInfoWarningBackgroundIllustration = dynamic(() =>
  import('./circle-info-warning-background.illustration').then(mod => mod.CircleInfoWarningBackgroundIllustration)
)
export const ClaroIllustration = dynamic(() => import('./claro.illustration').then(mod => mod.ClaroIllustration))
export const ClaroLandlineIllustration = dynamic(() =>
  import('./claro-landline.illustration').then(mod => mod.ClaroLandlineIllustration)
)
export const ClaroTvIllustration = dynamic(() => import('./claro-tv.illustration').then(mod => mod.ClaroTvIllustration))
export const CnpjAvatarIllustration = dynamic(() =>
  import('./cnpj-avatar.illustration').then(mod => mod.CnpjAvatarIllustration)
)
export const CoinErrorIllustration = dynamic(() =>
  import('./coin-error.illustration').then(mod => mod.CoinErrorIllustration)
)
export const CoinFailedIllustration = dynamic(() =>
  import('./coin-failed.illustration').then(mod => mod.CoinFailedIllustration)
)
export const CoinPaymentInTransactionIllustation = dynamic(() =>
  import('./coin-payment-in-transaction.illustration').then(mod => mod.CoinPaymentInTransactionIllustation)
)
export const CoinPaymentWaiting = dynamic(() =>
  import('./coin-payment-waiting.illustration').then(mod => mod.CoinPaymentWaiting)
)
export const CoinSuccessIllustration = dynamic(() =>
  import('./coin-success.illustration').then(mod => mod.CoinSuccessIllustration)
)
export const CoinsStackIllustration = dynamic(() =>
  import('./coins-stack.illustration').then(mod => mod.CoinsStackIllustration)
)
export const CoinsStackErrorIllustration = dynamic(() =>
  import('./coins-stack-error.illustration').then(mod => mod.CoinsStackErrorIllustration)
)
export const CoinsStackNeutralIllustration = dynamic(() =>
  import('./coins-stack-neutral.illustration').then(mod => mod.CoinsStackNeutralIllustration)
)
export const CoinsStackSuccessIllustration = dynamic(() =>
  import('./coins-stack-success.illustration').then(mod => mod.CoinsStackSuccessIllustration)
)
export const CorreiosIllustration = dynamic(() =>
  import('./correios.illustration').then(mod => mod.CorreiosIllustration)
)
export const CpfAvatarIllustration = dynamic(() =>
  import('./cpf-avatar.illustration').then(mod => mod.CpfAvatarIllustration)
)
export const CreditCardIllustration = dynamic(() =>
  import('./credit-card.illustration').then(mod => mod.CreditCardIllustration)
)
export const DisbursementConfirmedIllustration = dynamic(() =>
  import('./disbursement-confirmed.illustration').then(mod => mod.DisbursementConfirmedIllustration)
)
export const DocumentCheckedIllustration = dynamic(() =>
  import('./document-checked.illustration').then(mod => mod.DocumentCheckedIllustration)
)
export const DocumentSuccessIllustration = dynamic(() =>
  import('./document-success.illustration').then(mod => mod.DocumentSuccessIllustration)
)
export const DocumentsGreyAndGreenIllustration = dynamic(() =>
  import('./documents-grey-and-green.illustration').then(mod => mod.DocumentsGreyAndGreenIllustration)
)
export const DocumentsNeutralErrorIllustration = dynamic(() =>
  import('./documents-neutral-error.illustration').then(mod => mod.DocumentsNeutralErrorIllustration)
)
export const DogIllustration = dynamic(() => import('./dog.illustration').then(mod => mod.DogIllustration))
export const EmbratelIllustration = dynamic(() =>
  import('./embratel.illustration').then(mod => mod.EmbratelIllustration)
)
export const EmptyDocumentIllustration = dynamic(() =>
  import('./empty-document.illustration').then(mod => mod.EmptyDocumentIllustration)
)
export const ErrorCloudIllustration = dynamic(() =>
  import('./error-cloud.illustration').then(mod => mod.ErrorCloudIllustration)
)
export const ErrorInComunicationIllustration = dynamic(() =>
  import('./error-in-comunication.illustration').then(mod => mod.ErrorInComunicationIllustration)
)
export const ExclamationIllustration = dynamic(() =>
  import('./exclamation.illustration').then(mod => mod.ExclamationIllustration)
)
export const FailureIllustration = dynamic(() => import('./failure.illustration').then(mod => mod.FailureIllustration))
export const FollowUpBannerLoanCancelledIllustration = dynamic(() =>
  import('./follow-up-banner-loan-cancelled.illustration').then(mod => mod.FollowUpBannerLoanCancelledIllustration)
)
export const FreemiumAnalysisIllustration = dynamic(() =>
  import('./freemium-analysis.illustration').then(mod => mod.FreemiumAnalysisIllustration)
)
export const FreemiumEmailMissingIllustration = dynamic(() =>
  import('./freemium-email-missing.illustration').then(mod => mod.FreemiumEmailMissingIllustration)
)
export const FreemiumInviteBannerIllustration = dynamic(() =>
  import('./freemium-invite-banner.illustration').then(mod => mod.FreemiumInviteBannerIllustration)
)
export const FreemiumInviteNotificationIllustration = dynamic(() =>
  import('./freemium-invite-notification.illustration').then(mod => mod.FreemiumInviteNotificationIllustration)
)
export const FreemiumPartiallyRejectedIllustration = dynamic(() =>
  import('./freemium-partialy-rejected.illustration').then(mod => mod.FreemiumPartiallyRejectedIllustration)
)
export const FreemiumResponsePendingIllustration = dynamic(() =>
  import('./freemium-response-pending.illustration').then(mod => mod.FreemiumResponsePendingIllustration)
)
export const FreemiumResponsiveInviteBannerIllustration = dynamic(() =>
  import('./freemium-responsive-invite-banner.illustration').then(mod => mod.FreemiumResponsiveInviteBannerIllustration)
)
export const GiftBoxIllustration = dynamic(() => import('./gift-box.illustration').then(mod => mod.GiftBoxIllustration))
export const GirlAtCellphoneConfirmIdentityIllustration = dynamic(() =>
  import('./girl-at-cellphone-confirm-identity.illustration').then(
    mod => mod.GirlAtCellphoneConfirmIdentityIllustration
  )
)
export const GooglePlayBlackIllustration = dynamic(() =>
  import('./google-play-black.illustration').then(mod => mod.GooglePlayBlackIllustration)
)
export const GoogleStoreIllustration = dynamic(() =>
  import('./google-store.illustration').then(mod => mod.GoogleStoreIllustration)
)
export const GooglePlayIllustration = dynamic(() =>
  import('./googleplay.illustration').then(mod => mod.GooglePlayIllustration)
)
export const GreyBlockedLockerIllustration = dynamic(() =>
  import('./grey-blocked-locker.illustration').then(mod => mod.GreyBlockedLockerIllustration)
)
export const HandWithCellphoneIllustration = dynamic(() =>
  import('./hand-with-cellphone.illustration').then(mod => mod.HandWithCellphoneIllustration)
)
export const HighFiveIllustration = dynamic(() =>
  import('./high-five.illustration').then(mod => mod.HighFiveIllustration)
)
export const HomeModalNewPageIllustration = dynamic(() =>
  import('./home-modal-new-page.illustration').then(mod => mod.HomeModalNewPageIllustration)
)
export const HomeTransactionDisputeHelpIllustration = dynamic(() =>
  import('./home-transaction-dispute-help.illustration').then(mod => mod.HomeTransactionDisputeHelpIllustration)
)
export const HomeTransactionDisputeWarningIllustration = dynamic(() =>
  import('./home-transaction-dispute-warning.illustration').then(mod => mod.HomeTransactionDisputeWarningIllustration)
)
export const HouseIllustration = dynamic(() => import('./house.illustration').then(mod => mod.HouseIllustration))
export const IdAssessmentIllustration = dynamic(() =>
  import('./id-assessment.illustration').then(mod => mod.IdAssessmentIllustration)
)
export const IdentityIllustration = dynamic(() =>
  import('./identity.illustration').then(mod => mod.IdentityIllustration)
)
export const IfoodIllustration = dynamic(() => import('./ifood.illustration').then(mod => mod.IfoodIllustration))
export const InfoPendingIllustration = dynamic(() =>
  import('./info-pending.illustration').then(mod => mod.InfoPendingIllustration)
)
export const InsuranceBannerIllustration = dynamic(() =>
  import('./insurance-banner.illustration').then(mod => mod.InsuranceBannerIllustration)
)
export const InsuranceCardLifeIllustration = dynamic(() =>
  import('./insurance-card-life.illustration').then(mod => mod.InsuranceCardLifeIllustration)
)
export const InsuranceCardStoreIllustration = dynamic(() =>
  import('./insurance-card-store.illustration').then(mod => mod.InsuranceCardStoreIllustration)
)
export const InsuranceLifeBannerIllustration = dynamic(() =>
  import('./insurance-life-banner.illustration').then(mod => mod.InsuranceLifeBannerIllustration)
)
export const InsuranceStatusLoadingIllustration = dynamic(() =>
  import('./insurance-status-loading.illustration').then(mod => mod.InsuranceStatusLoadingIllustration)
)
export const InsuranceStoreBannerIllustration = dynamic(() =>
  import('./insurance-store-banner.illustration').then(mod => mod.InsuranceStoreBannerIllustration)
)
export const InsuranceTransactionBannerIllustration = dynamic(() =>
  import('./insurance-transaction-banner.illustration').then(mod => mod.InsuranceTransactionBannerIllustration)
)
export const InternalServerErrorIllustration = dynamic(() =>
  import('./internal-server-error.illustration').then(mod => mod.InternalServerErrorIllustration)
)
export const InvitationSignupMailExpired = dynamic(() =>
  import('./invitation-signup-mail-expired.illustration').then(mod => mod.InvitationSignupMailExpired)
)
export const KeyLoadingIllustration = dynamic(() =>
  import('./key-loading.illustration').then(mod => mod.KeyLoadingIllustration)
)
export const KeyRejectedIllustration = dynamic(() =>
  import('./key-rejected.illustration').then(mod => mod.KeyRejectedIllustration)
)
export const KycAnalysisIllustration = dynamic(() =>
  import('./kyc-analysis.illustration').then(mod => mod.KycAnalysisIllustration)
)
export const KycAssessmentRedirectToMobileIllustration = dynamic(() =>
  import('./kyc-assessment-redirect-to-mobile.illustration').then(mod => mod.KycAssessmentRedirectToMobileIllustration)
)
export const KycConfirmationEmailIllustration = dynamic(() =>
  import('./kyc-confirmation-email.illustration').then(mod => mod.KycConfirmationEmailIllustration)
)
export const KycCreateAccountIllustration = dynamic(() =>
  import('./kyc-create-account.illustration').then(mod => mod.KycCreateAccountIllustration)
)
export const KycOnboardingFreemiumIllustration = dynamic(() =>
  import('./kyc-onboarding-freemium.illustration').then(mod => mod.KycOnboardingFreemiumIllustration)
)
export const KycRejectedIllustration = dynamic(() =>
  import('./kyc-rejected.illustration').then(mod => mod.KycRejectedIllustration)
)
export const LeagueOfLegendsIllustration = dynamic(() =>
  import('./leagueoflegends.illustration').then(mod => mod.LeagueOfLegendsIllustration)
)
export const LiquidGlassIllustration = dynamic(() =>
  import('./liquid-glass.illustration').then(mod => mod.LiquidGlassIllustration)
)
export const LoadingMoreIllustration = dynamic(() =>
  import('./loading-more.illustration').then(mod => mod.LoadingMoreIllustration)
)
export const LockBadgeIllustration = dynamic(() =>
  import('./lock-badge.illustration').then(mod => mod.LockBadgeIllustration)
)
export const LoginDeviceAuthorizationIllustration = dynamic(() =>
  import('./login-device-challenge-message.illustration').then(mod => mod.LoginDeviceAuthorizationIllustration)
)
export const LoginDeviceSmallMobileAuthorizationIllustration = dynamic(() =>
  import('./login-device-challenge-message.illustration').then(
    mod => mod.LoginDeviceSmallMobileAuthorizationIllustration
  )
)
export const MachineIllustration = dynamic(() => import('./machine.illustration').then(mod => mod.MachineIllustration))
export const MaintenanceIllustration = dynamic(() =>
  import('./maintenance.illustration').then(mod => mod.MaintenanceIllustration)
)
export const MovingCoinIllustration = dynamic(() =>
  import('./moving-coin.illustration').then(mod => mod.MovingCoinIllustration)
)
export const NewAccountSwitch = dynamic(() =>
  import('./new-account-switch.illustration').then(mod => mod.NewAccountSwitch)
)
export const NextelIllustration = dynamic(() => import('./nextel.illustration').then(mod => mod.NextelIllustration))
export const NotFoundIllustration = dynamic(() =>
  import('./not-found.illustration').then(mod => mod.NotFoundIllustration)
)
export const NpsFeedbackIllustration = dynamic(() =>
  import('./nps-feedback.illustration').then(mod => mod.NpsFeedbackIllustration)
)
export const NpsFeedbackSentIllustration = dynamic(() =>
  import('./nps-feedback-sent.illustration').then(mod => mod.NpsFeedbackSentIllustration)
)
export const NpsModalIllustration = dynamic(() =>
  import('./nps-modal.illustration').then(mod => mod.NpsModalIllustration)
)
export const NpsTokenExpiredIllustration = dynamic(() =>
  import('./nps-token-expired.illustration').then(mod => mod.NpsTokenExpiredIllustration)
)
export const OiIllustration = dynamic(() => import('./oi.illustration').then(mod => mod.OiIllustration))
export const OiLandlineIllustration = dynamic(() =>
  import('./oi-landline.illustration').then(mod => mod.OiLandlineIllustration)
)
export const OnboardingCoinsIllustration = dynamic(() =>
  import('./onboarding-coins.illustration').then(mod => mod.OnboardingCoinsIllustration)
)
export const OnboardingIncomeMoneyIllustration = dynamic(() =>
  import('./onboarding-income-money.illustration').then(mod => mod.OnboardingIncomeMoneyIllustration)
)
export const OnboardingMoneyYieldsIllustration = dynamic(() =>
  import('./onboarding-money-yields.illustration').then(mod => mod.OnboardingMoneyYieldsIllustration)
)
export const OnboardingPiggyIllustration = dynamic(() =>
  import('./onboarding-piggy.illustration').then(mod => mod.OnboardingPiggyIllustration)
)
export const OnboardingSafeMoneyIllustration = dynamic(() =>
  import('./onboarding-safe-money.illustration').then(mod => mod.OnboardingSafeMoneyIllustration)
)
export const OpenFinanceIllustration = dynamic(() =>
  import('./open-finance.illustration').then(mod => mod.OpenFinanceIllustration)
)
export const OpenFinanceRedirectIllustration = dynamic(() =>
  import('./open-finance-redirect.illustration').then(mod => mod.OpenFinanceRedirectIllustration)
)
export const PaperAirplaneIllustration = dynamic(() =>
  import('./paper-airplane.illustration').then(mod => mod.PaperAirplaneIllustration)
)
export const PaperAirplaneLinkIllustration = dynamic(() =>
  import('./paper-airplane-link.illustration').then(mod => mod.PaperAirplaneLinkIllustration)
)
export const PaperAirplaneLinkErrorIllustration = dynamic(() =>
  import('./paper-airplane-link-error.illustration').then(mod => mod.PaperAirplaneLinkErrorIllustration)
)
export const PaperDocumentsErrorIllustration = dynamic(() =>
  import('./paper-documents-error.illustration').then(mod => mod.PaperDocumentsErrorIllustration)
)
export const PapersDocumentIllustration = dynamic(() =>
  import('./papers-documents.illustration').then(mod => mod.PapersDocumentIllustration)
)
export const PaymentLinkErrorCreateModalIllustration = dynamic(() =>
  import('./payment-link-error-create-modal.illustration').then(mod => mod.PaymentLinkErrorCreateModalIllustration)
)
export const PaymentLinkHomeBannerIllustration = dynamic(() =>
  import('./payment-link-home-banner.illustration').then(mod => mod.PaymentLinkHomeBannerIllustration)
)
export const PaymentLinkSuccessCreateModalIllustration = dynamic(() =>
  import('./payment-link-success-create-modal.illustration').then(mod => mod.PaymentLinkSuccessCreateModalIllustration)
)
export const PaymentLinksBannerIllustration = dynamic(() =>
  import('./payment-links-banner.illustration').then(mod => mod.PaymentLinksBannerIllustration)
)
export const PaymentSuccessIllustration = dynamic(() =>
  import('./payment-success.illustration').then(mod => mod.PaymentSuccessIllustration)
)
export const PendingKYCIllustration = dynamic(() =>
  import('./pending-kyc.illustration').then(mod => mod.PendingKYCIllustration)
)
export const PhonePaperAirplaneIllustration = dynamic(() =>
  import('./phone-paper-airplane.illustration').then(mod => mod.PhonePaperAirplaneIllustration)
)
export const PiggyBankIllustration = dynamic(() =>
  import('./piggy-bank.illustration').then(mod => mod.PiggyBankIllustration)
)
export const PiggyBankNeutralErrorIllustration = dynamic(() =>
  import('./piggy-bank-neutral-error.illustration').then(mod => mod.PiggyBankNeutralErrorIllustration)
)
export const PinBlockedFaceAnalysisIllustration = dynamic(() =>
  import('./pin-blocked-face-analysis.illustration').then(mod => mod.PinBlockedFaceAnalysisIllustration)
)
export const PinBlockedLockerIllustration = dynamic(() =>
  import('./pin-blocked-locker.illustration').then(mod => mod.PinBlockedLockerIllustration)
)
export const PinRegisterIllustration = dynamic(() =>
  import('./pin-register.illustration').then(mod => mod.PinRegisterIllustration)
)
export const PinRegisterSuccessIllustration = dynamic(() =>
  import('./pin-register.illustration').then(mod => mod.PinRegisterSuccessIllustration)
)
export const PixKeyNoKeysIllustration = dynamic(() =>
  import('./pix-key-no-keys.illustration').then(mod => mod.PixKeyNoKeysIllustration)
)
export const PixKeyRegistrationBannerIllustration = dynamic(() =>
  import('./pix-key-registration-banner.illustration').then(mod => mod.PixKeyRegistrationBannerIllustration)
)
export const PsnStoreIllustration = dynamic(() =>
  import('./psnstore.illustration').then(mod => mod.PsnStoreIllustration)
)
export const QrCodeSmartphoneIllustration = dynamic(() =>
  import('./qr-code-smartphone.illustration').then(mod => mod.QrCodeSmartphoneIllustration)
)
export const RavAutomaticChecked = dynamic(() =>
  import('./rav-automatic-request-modal.illustration').then(mod => mod.RavAutomaticChecked)
)
export const RavDailyReceivableBannerFollowUpIllustration = dynamic(() =>
  import('./rav-daily-receivable-followup-banner.illustration').then(
    mod => mod.RavDailyReceivableBannerFollowUpIllustration
  )
)
export const RavDailyReceivableBannerOfferIllustration = dynamic(() =>
  import('./rav-daily-receivable-offer-banner.illustration').then(mod => mod.RavDailyReceivableBannerOfferIllustration)
)
export const RavDailyReceivableSameDayBannerIlustrationSVG = dynamic(() =>
  import('./rav-daily-receivable-same-day-banner.illustration').then(
    mod => mod.RavDailyReceivableSameDayBannerIlustrationSVG
  )
)
export const RavDailyReceivableSameDayBannerIllustrationV2SVG = dynamic(() =>
  import('./rav-daily-receivable-same-day-banner-v2.illustration').then(
    mod => mod.RavDailyReceivableSameDayBannerIllustrationV2SVG
  )
)
export const RavHistoryEmptyIllustration = dynamic(() =>
  import('./rav-history-empty-state.illustration').then(mod => mod.RavHistoryEmptyIllustration)
)
export const RavSpotPrepaymentError = dynamic(() =>
  import('./rav-spot-alert-error.illustration').then(mod => mod.RavSpotPrepaymentError)
)
export const RavSpotRedirectIllustration = dynamic(() =>
  import('./rav-spot-sidebar-steps.illustration').then(mod => mod.RavSpotRedirectIllustration)
)
export const RavStoneAccountQRCode = dynamic(() =>
  import('./rav-stone-account-qr-code.illustration').then(mod => mod.RavStoneAccountQRCode)
)
export const ReceivablesSettlementEveryDayBannerIllustration = dynamic(() =>
  import('./receivables-settlement-everyday-banner.illustration').then(
    mod => mod.ReceivablesSettlementEveryDayBannerIllustration
  )
)
export const RedirectToMobileIllustration = dynamic(() =>
  import('./redirect-to-mobile.illustration').then(mod => mod.RedirectToMobileIllustration)
)
export const RefundDialogIllustration = dynamic(() =>
  import('./refund-dialog.illustration').then(mod => mod.RefundDialogIllustration)
)
export const RegistrationStoreIllustration = dynamic(() =>
  import('./registration-store.illustration').then(mod => mod.RegistrationStoreIllustration)
)
export const RequestBobinaSuccessIllustration = dynamic(() =>
  import('./request-bobina-success.illustration').then(mod => mod.RequestBobinaSuccessIllustration)
)
export const RequestedLoanStatusIllustration = dynamic(() =>
  import('./requested-loan-status-steps.illustration').then(mod => mod.RequestedLoanStatusIllustration)
)
export const ResetPasswordIllustration = dynamic(() =>
  import('./reset-password.illustration').then(mod => mod.ResetPasswordIllustration)
)
export const ResetPinIllustration = dynamic(() =>
  import('./reset-pin.illustration').then(mod => mod.ResetPinIllustration)
)
export const SaleSimulatorBannerIllustration = dynamic(() =>
  import('./sale-simulator-banner.illustration').then(mod => mod.SaleSimulatorBannerIllustration)
)
export const ConfirmSaleIllustration = dynamic(() =>
  import('./sales-confirm-transaction.illustration').then(mod => mod.ConfirmSaleIllustration)
)
export const SalesHomePixPosTerminalInfoIllustration = dynamic(() =>
  import('./sales-home-pix-pos-terminal-info.illustration').then(mod => mod.SalesHomePixPosTerminalInfoIllustration)
)
export const SaleWithCancellationError = dynamic(() =>
  import('./sales-with-cancellation-error.illustration').then(mod => mod.SaleWithCancellationError)
)
export const SecurityHomeBannerIllustration = dynamic(() =>
  import('./security-home-banner.illustration').then(mod => mod.SecurityHomeBannerIllustration)
)
export const SecurityOtpLockIllustration = dynamic(() =>
  import('./security-otp-lock.illustration').then(mod => mod.SecurityOtpLockIllustration)
)
export const SercomtelLandlineIllustration = dynamic(() =>
  import('./sercomtel-landline.illustration').then(mod => mod.SercomtelLandlineIllustration)
)
export const ServingCustomerIllustration = dynamic(() =>
  import('./serving-customer.illustration').then(mod => mod.ServingCustomerIllustration)
)
export const SettlementCalendarIllustration = dynamic(() =>
  import('./settlement-calendar.illustration').then(mod => mod.SettlementCalendarIllustration)
)
export const CoinRefresh = dynamic(() => import('./shared-coin-refresh.illustration').then(mod => mod.CoinRefresh))
export const CoinNegativeError = dynamic(() =>
  import('./shared-negative-coin-error.illustration').then(mod => mod.CoinNegativeError)
)
export const SkyTvIllustration = dynamic(() => import('./sky-tv.illustration').then(mod => mod.SkyTvIllustration))
export const SpeakerIllustration = dynamic(() => import('./speaker.illustration').then(mod => mod.SpeakerIllustration))
export const SpinnerIllustration = dynamic(() => import('./spinner.illustration').then(mod => mod.SpinnerIllustration))
export const SpotifyIllustration = dynamic(() => import('./spotify.illustration').then(mod => mod.SpotifyIllustration))
export const SteamIllustration = dynamic(() => import('./steam.illustration').then(mod => mod.SteamIllustration))
export const StoreIllustration = dynamic(() => import('./store.illustration').then(mod => mod.StoreIllustration))
export const StoreNeutralErrorIllustration = dynamic(() =>
  import('./store-neutral-error.illustration').then(mod => mod.StoreNeutralErrorIllustration)
)
export const SuccessIllustration = dynamic(() => import('./success.illustration').then(mod => mod.SuccessIllustration))
export const SuccessCheckedIllustration = dynamic(() =>
  import('./success-checked.illustration').then(mod => mod.SuccessCheckedIllustration)
)
export const SuccessPhoneOnHandIllustration = dynamic(() =>
  import('./success-phone-on-hand.illustration').then(mod => mod.SuccessPhoneOnHandIllustration)
)
export const TeamListConsultingIllustration = dynamic(() =>
  import('./team-list-consulting.illustration').then(mod => mod.TeamListConsultingIllustration)
)
export const TeamListSalesmanDuoIllustration = dynamic(() =>
  import('./team-list-salesman-duo.illustration').then(mod => mod.TeamListSalesmanDuoIllustration)
)
export const TeamListSittingCustomerIllustration = dynamic(() =>
  import('./team-list-sitting-customer.illustration').then(mod => mod.TeamListSittingCustomerIllustration)
)
export const TerminalIllustration = dynamic(() =>
  import('./terminal.illustration').then(mod => mod.TerminalIllustration)
)
export const TerminalSerialNumberIllustration = dynamic(() =>
  import('./terminal-serial-number.illustration').then(mod => mod.TerminalSerialNumberIllustration)
)
export const ThumbsUpIllustration = dynamic(() =>
  import('./thumbs-up.illustration').then(mod => mod.ThumbsUpIllustration)
)
export const TimIllustration = dynamic(() => import('./tim.illustration').then(mod => mod.TimIllustration))
export const TransactionalLimitsSunIllustration = dynamic(() =>
  import('./transactional-limits-sun.illustration').then(mod => mod.TransactionalLimitsSunIllustration)
)
export const UberIllustration = dynamic(() => import('./uber.illustration').then(mod => mod.UberIllustration))
export const UnauthorizedIllustration = dynamic(() =>
  import('./unauthorized.illustration').then(mod => mod.UnauthorizedIllustration)
)
export const UpsellBannerIllustration = dynamic(() =>
  import('./upsell-banner.illustration').then(mod => mod.UpsellBannerIllustration)
)
export const UserPfIllustration = dynamic(() => import('./user-pf.illustration').then(mod => mod.UserPfIllustration))
export const VerifyEmailClockIllustration = dynamic(() =>
  import('./verify-email-clock.illustration').then(mod => mod.VerifyEmailClockIllustration)
)
export const VerifyEmailIdentityRecoveryIllustration = dynamic(() =>
  import('./verify-email-identity-recovery.illustration').then(mod => mod.VerifyEmailIdentityRecoveryIllustration)
)
export const VivoIllustration = dynamic(() => import('./vivo.illustration').then(mod => mod.VivoIllustration))
export const VolumeExemptionIllustration = dynamic(() =>
  import('./volume-exemption-terminals.illustration').then(mod => mod.VolumeExemptionIllustration)
)
export const VolumeExemptionTwoIllustration = dynamic(() =>
  import('./volume-exemption-terminals.illustration').then(mod => mod.VolumeExemptionTwoIllustration)
)
export const WalletNeutralErrorIllustration = dynamic(() =>
  import('./wallet-neutral-error.illustration').then(mod => mod.WalletNeutralErrorIllustration)
)
export const WarningIllustration = dynamic(() => import('./warning.illustration').then(mod => mod.WarningIllustration))
export const WarningDialogIllustration = dynamic(() =>
  import('./warning-dialog.illustration').then(mod => mod.WarningDialogIllustration)
)
export const WarningNotificationIllustration = dynamic(() =>
  import('./warning-notification.illustration').then(mod => mod.WarningNotificationIllustration)
)
export const WomanOnCalendarIllustration = dynamic(() =>
  import('./woman-on-calendar.illustration').then(mod => mod.WomanOnCalendarIllustration)
)
export const WomanOnRollerSkaterIllustration = dynamic(() =>
  import('./woman-on-roller-skater.illustration').then(mod => mod.WomanOnRollerSkaterIllustration)
)
export const XboxGiftCardIllustration = dynamic(() =>
  import('./xboxgitfcard.illustration').then(mod => mod.XboxGiftCardIllustration)
)
export const XboxLiveIllustration = dynamic(() =>
  import('./xboxlive.illustration').then(mod => mod.XboxLiveIllustration)
)
